import { useState, useEffect } from 'react';
import { heroComics } from '@/mocks/home';

export default function HeroSection() {
  const [activeCard, setActiveCard] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveCard((prev) => (prev + 1) % heroComics.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  const getTagBg = (color: string) => {
    if (color === 'accent') return 'bg-accent-500';
    return 'bg-primary-500';
  };

  const getCardRotation = (index: number) => {
    const centerIndex = 1;
    const offset = index - centerIndex;
    return `rotate(${offset * 6}deg) translateY(${Math.abs(offset) * 12}px)`;
  };

  const getCardZIndex = (index: number) => {
    return 10 - Math.abs(index - 1);
  };

  return (
    <section className="relative min-h-screen flex flex-col items-center justify-center overflow-hidden bg-background-50 pt-16">
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-40 -right-40 w-[500px] h-[500px] rounded-full bg-accent-100/30 blur-3xl"></div>
        <div className="absolute -bottom-20 -left-20 w-[400px] h-[400px] rounded-full bg-primary-100/20 blur-3xl"></div>
      </div>

      <div className="relative z-10 w-full flex flex-col items-center px-4 md:px-10">
        <div className="text-center max-w-3xl mx-auto mb-8 md:mb-10 mt-6 md:mt-10">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-100/80 text-accent-700 text-xs md:text-sm font-medium mb-5 md:mb-6">
            <i className="ri-fire-line text-sm"></i>
            <span>韩漫无删减 · 每日大赛独家吃瓜基地</span>
          </div>
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-black text-foreground-950 leading-tight">
            歪歪漫画
            <span className="text-accent-500">免费看</span>
          </h1>
          <p className="font-heading text-xl md:text-3xl lg:text-4xl font-bold text-foreground-700 mt-2 md:mt-3">
            韩漫无删减每日大赛
          </p>
          <p className="mt-5 md:mt-6 text-sm md:text-base text-foreground-600 max-w-xl mx-auto leading-relaxed">
            歪歪漫画网提供歪歪漫画免费网站入口与韩国无遮羞漫画资源，韩漫歪歪漫画免费看每日大赛实时上线。网红反差视频、明星塌房内幕大瓜全网首发，火速围观不迷路！
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mt-7 md:mt-8">
            <a
              href="#hot"
              className="px-8 py-3 rounded-full bg-primary-500 text-background-50 text-sm md:text-base font-semibold hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              一键进入 · 开始阅读
            </a>
            <a
              href="#featured"
              className="px-8 py-3 rounded-full text-sm md:text-base font-medium text-foreground-700 hover:text-accent-500 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              浏览漫画库 <i className="ri-arrow-right-line ml-1 align-middle"></i>
            </a>
          </div>
        </div>

        <div className="relative w-full max-w-4xl mx-auto h-[280px] md:h-[380px] lg:h-[440px] flex items-center justify-center perspective-[1200px]">
          {heroComics.map((comic, index) => (
            <div
              key={comic.id}
              className={`absolute w-[180px] md:w-[220px] lg:w-[260px] transition-all duration-700 ease-in-out cursor-pointer ${
                index === activeCard
                  ? 'z-20 scale-100 opacity-100'
                  : index === (activeCard + 1) % heroComics.length
                  ? 'z-10 scale-90 opacity-75 translate-x-[160px] md:translate-x-[200px] lg:translate-x-[240px]'
                  : 'z-0 scale-80 opacity-50 -translate-x-[160px] md:-translate-x-[200px] lg:-translate-x-[240px]'
              }`}
              onClick={() => setActiveCard(index)}
            >
              <div className="relative rounded-2xl overflow-hidden bg-background-100 aspect-[3/4]">
                <img
                  src={comic.coverImage}
                  alt={comic.title}
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                  title={`歪歪漫画 - ${comic.title}`}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-primary-950/70 via-transparent to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className={`px-2.5 py-1 rounded-full text-xs font-medium text-background-50 ${getTagBg(comic.tagColor)}`}>
                    {comic.tag}
                  </span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 px-4 py-4">
                  <p className="text-xs text-background-50/70 font-medium">{comic.category}</p>
                  <h3 className="text-sm md:text-base font-bold text-background-50 mt-0.5">{comic.title}</h3>
                  <p className="text-xs text-background-50/60 mt-0.5">{comic.subtitle}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="flex items-center gap-2 mt-4 md:mt-6">
          {heroComics.map((_, index) => (
            <button
              key={index}
              onClick={() => setActiveCard(index)}
              className={`w-2 h-2 rounded-full transition-all duration-300 cursor-pointer ${
                index === activeCard
                  ? 'w-6 bg-accent-500'
                  : 'bg-secondary-300 hover:bg-secondary-400'
              }`}
              aria-label={`Go to card ${index + 1}`}
            ></button>
          ))}
        </div>
      </div>
    </section>
  );
}